<template>
  <v-card flat class="rounded-lg mb-2">
    <v-row @click="openOrder()" style="cursor: pointer">
      <v-col xl="2" lg="2" md="6" sm="12">
        <span v-if="order.assigned">
          <v-icon small>$inbox</v-icon>
          {{ order.order_number }}
        </span>
        <span v-if="!order.assigned">
          <v-chip label small color="primary" class="px-1"> Pending </v-chip>
        </span>
        <v-tooltip top class="rounded-20">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              small
              v-show="order.awaiting_response"
              class="rounded-10 mr-1 notification-warning"
            >
              <v-icon small class="">$alarm</v-icon>
            </v-chip>
          </template>
          <span class="rounded-20">Awaiting Approval Response</span>
        </v-tooltip>
        <v-tooltip top class="rounded-10">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              small
              dark
              v-show="order.new_message"
              class="rounded-10 primary"
            >
              <v-icon small class="">mdi-message-outline</v-icon>
            </v-chip>
          </template>
          <span>New Message</span>
        </v-tooltip>
      </v-col>
      <v-col xl="2" lg="2" md="6" sm="12">
        <v-icon color="secondary" small>mdi-office-building-outline</v-icon>
        {{ order.client_name }}
      </v-col>
      <v-col xl="2" lg="2" md="6" sm="12">
        <span v-if="order.assigned">
          <v-icon color="secondary" small>mdi-account-outline</v-icon>
          {{ order.patient_reference }}
        </span>
        <span v-if="!order.assigned">
          {{ order.patient_reference }}
          <v-chip color="primary" small label class="px-1"> Existing </v-chip>
        </span>
      </v-col>
      <v-col xl="3" lg="3" md="6" sm="12">
        <v-chip
          small
          outlined
          v-if="
            order.sessions.find((s) => {
              return s.is_photogrammetry
            })
          "
          class="rounded-10 mr-1 px-2"
        >
          PHOTOGRAMMETRY
        </v-chip>
        <span v-for="(status, index) in order.statuses" :key="index">
          <v-chip
            small
            outlined
            v-if="status === 'exported'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$implantexport</v-icon>
            IMPLANTS EXPORTED
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'design'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$toothdesigns</v-icon>
            DESIGN ONLY
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'bar'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$milledbar</v-icon>
            MILLED BAR
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'finished_case'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$finishedprosthetic</v-icon>
            FINISHED CASE
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'virtual_smile_design'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$virtualSmileDesign</v-icon>
            VSD
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'immediate_design'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$immediateDesign</v-icon>
            IMMEDIATE DESIGN
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'immediate_bridge'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$surgicalTool</v-icon>
            IMMEDIATE BRIDGE
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'immediate_nexus_360'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$surgicalTool</v-icon>
            IMMEDIATE NEXUS 360°
          </v-chip>
          <v-chip
            small
            outlined
            v-if="status === 'archived'"
            class="rounded-10 mr-1 px-2"
          >
            <v-icon small class="mr-1">$inboxarchive</v-icon>
            ARCHIVED
          </v-chip>
        </span>
      </v-col>
      <v-col xl="1" lg="1" md="6" sm="12" class="py-0 align-self-center">
        <v-icon v-if="dentate === 'upper'" size="40" class="mr-3">
          $singlearch
        </v-icon>
        <v-icon v-if="dentate === 'lower'" size="40" class="mr-3">
          $lowerarch
        </v-icon>
        <v-icon v-if="dentate === 'both'" size="40" class="mr-3">
          $dualarch
        </v-icon>
        <span style="white-space: nowrap">
          <v-icon color="secondary" small>mdi-update</v-icon>
          {{ order.sessions.length }}
        </span>
      </v-col>
      <v-col xl="2" lg="2" md="6" sm="12">
        <v-icon color="secondary" small>mdi-clock-outline</v-icon>
        {{ order.created_at | luxon({ output: { format: "med" } }) }}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "OrderCard",

  props: ["order"],

  computed: {
    dentate() {
      if (this.order.dentates.length > 1) return "both"
      else return this.order.dentates[0]
    }
  },

  methods: {
    openOrder() {
      this.$emit("open", this.order)
    }
  }
}
</script>
